
<div class="header">
  <strong [ngClass]="[(resource.rarity || 'common').toLowerCase()]" class="name">
    <app-real-name [name]="resource.internalId ?? ''"></app-real-name> &middot; {{ resource.category }}
  </strong>
</div>

<div class="description">
  {{ resource.description }}
</div>

<div class="quantity" *ngIf="showQuantity">
  <ng-container *ngIf="resources$ | async as resources">
    <em><small>You have {{ resources[resource.internalId ?? ''] || 0 | number }} of these.</small></em>
  </ng-container>
</div>
